import React from "react";
import Laptop from "../../Laptop";
import separator6 from "../../shapes/separator-6.svg";
import SectionTitle from "../components/SectionTitle";

export default function SkillsSection() {
  return (
    <div className="section relative container skills-section px-5 col-center">
      <SectionTitle title="Skills" className="mt-10" />
      <div className="flex w-full flex-col items-center justify-between lg:flex-row">
        <div className="flex flex-col self-start mt-40 mb-40 w-full max-w-none pl-5 text-left lg:mb-40 lg:w-1/2">
          <p>
            I'm a Senior Frontend Engineer and UI/UX Designer with experience
            shipping production software at major banks and tech companies
            across Southeast Asia. I build end-to-end — from{" "}
            <span className="text-pal-blue">*</span>design systems and
            pixel-perfect interfaces to{" "}
            <span className="text-pal-blue">*</span>backend services and CI/CD
            pipelines. My toolkit spans:
            <br /> <span className="text-pal-blue">*</span>React, Angular,
            TypeScript, Node JS <br />
            <span className="text-pal-blue">*</span>HTML, CSS, Sass, Material UI{" "}
            <br />
            <span className="text-pal-blue">*</span>Figma, Adobe Illustrator{" "}
            <br />
            <span className="text-pal-blue">*</span>AWS, Jenkins, SonarQube,
            Git <br />
            I'm not tied to any single stack — I adapt to whatever the project
            demands and deliver polished, production-ready software from concept
            to deployment.
          </p>
        </div>
        <div className="skills-laptop-wrap flex w-full shrink-0 flex-col items-center lg:mx-10 lg:min-w-0 lg:flex-1 lg:flex-row lg:items-end lg:justify-end">
          <div className="skills-laptop-panel relative z-10 inline-flex w-full max-w-full flex-col items-center lg:inline-flex lg:w-auto">
            <div className="skills-laptop-backdrop" aria-hidden />
            <div className="skills-laptop-art relative z-10 w-full">
              <div className="codec-shell__crt skills-laptop-crt">
                <div className="hero-face-wrap">
                  <div className="hero-face-glitch">
                    <div className="hero-face-glitch__channel hero-face-glitch__channel--cyan">
                      <Laptop className="hero-face-svg" animate={false} />
                    </div>
                    <div className="hero-face-glitch__channel hero-face-glitch__channel--magenta">
                      <Laptop className="hero-face-svg" animate={false} />
                    </div>
                    <Laptop className="hero-face-glitch__base hero-face-svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="about-section-separator about-section-separator--skills pointer-events-none absolute bottom-0 left-0 right-0 z-10 box-border select-none"
        style={{
          backgroundImage: `url(${separator6})`,
        }}
        aria-hidden
      />
    </div>
  );
}
